import { render } from "./BranchDotPopover.vue?vue&type=template&id=c716b84e"
import script from "./BranchDotPopover.vue?vue&type=script&lang=js"
export * from "./BranchDotPopover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__